import { apiRequest } from "../client/apiClient";
import { retryRequest } from "../helpers/retryRequest";

export async function fetchIncludedFeatures(searchString) {
  return retryRequest(() =>
    apiRequest(`/includedfeatures${searchString ? `?${searchString}` : ``}`),
  );
}

// Fetch every relation, including inactive ones; the feature's denormalized
// class-code field can be out of sync with these records.
export async function fetchFeatureClassRelations(featureId, language) {
  const pageSize = 100;
  const results = [];
  let total;
  do {
    const query = new URLSearchParams({
      language, skip: String(results.length), top: String(pageSize),
      includeTotals: "true", sortAsc: "id", searchOn: "includedFeatureFeatureId",
      search: featureId, caseInsensitiveSearch: "true",
    });
    const response = await fetchIncludedFeatures(query.toString());
    if (response instanceof Response || !Array.isArray(response?.results) ||
        !Number.isFinite(response.total)) {
      throw new Error("Unable to load class relationships");
    }
    total = response.total;
    if (!response.results.length && results.length < total) {
      throw new Error("Incomplete class relationships response");
    }
    results.push(...response.results);
  } while (results.length < total);

  return results
    .filter((item) => item.includedFeatureFeatureId === featureId)
    .map((item) => {
      const id = item.includedFeatureClassCode;
      if (!id) throw new Error("Class relationship has no class code");
      const details = item.classes?.find((entry) => (entry.classCode ?? entry.id) === id) ?? {};
      const name = details.classDisplayName || details.className || "";
      return { ...details, id, displayName: name ? `${id} | ${name}` : id,
        classDisplayName: name || id, deleted: false };
    });
}

export async function saveIncludedFeature(includedFeature) {
  return retryRequest(() =>
    apiRequest("/includedfeature/add", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(includedFeature),
    }),
  );
}

export async function saveIncludedFeatures(includedFeatures) {
  return retryRequest(() =>
    //const response = await
    apiRequest("/includedfeature/addbulk", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(includedFeatures),
    }),
  );

  return response;
}

/*export async function editIncludedFeature(includedFeature) {
  const response = await apiRequest(
    `/includedfeature/edit/${includedFeature.includedFeatureUniqueId}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(includedFeature),
    },
  );

  return response;
}*/

export async function editIncludedFeature(includedFeature) {
  return retryRequest(() =>
    apiRequest(
      `/includedfeature/edit/${includedFeature.includedFeatureUniqueId}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(includedFeature),
      },
    ),
  );
}

export async function deleteIncludedFeature(includedFeature) {
  return retryRequest(() =>
    apiRequest(
      `/includedfeature/delete/${includedFeature.includedFeatureUniqueId}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      },
    ),
  );
}
